// COPY de apps/desktop/src/...; dedup em F13 via packages/shared-ui.
import type { HTMLAttributes, ReactNode } from 'react';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  padding?: 'default' | 'compact';
  children: ReactNode;
}

export function Card({ padding = 'default', children, ...rest }: CardProps) {
  return (
    <div className="ds-card" data-padding={padding} {...rest}>
      {children}
    </div>
  );
}
